import { useAuth } from '@/lib/auth-context';
import { useMemo } from 'react';

export function usePermissions() {
  const { user, hasPermission, hasAnyPermission, hasAllPermissions } = useAuth();

  const permissions = useMemo(() => ({
    // Tenant permissions
    canViewTenants: hasPermission('hub.tenants.read'),
    canManageTenants: hasPermission('hub.tenants.write'),

    // User permissions
    canViewUsers: hasPermission('hub.users.read'),
    canManageUsers: hasPermission('hub.users.write'),
    canInviteUsers: hasPermission('hub.users.invite'),

    // Role permissions
    canViewRoles: hasPermission('hub.roles.read'),
    canManageRoles: hasPermission('hub.roles.write'),

    // App permissions
    canViewApps: hasPermission('hub.apps.read'),
    canManageApps: hasPermission('hub.apps.write'),

    // Audit permissions
    canViewAudit: hasPermission('hub.audit.read'),
    canExportAudit: hasPermission('hub.audit.export'),

    // Admin check
    isAdmin: hasAnyPermission([
      'hub.tenants.write',
      'hub.users.write',
      'hub.roles.write',
      'hub.apps.write',
    ]),

    // Check arbitrary permission
    has: hasPermission,
    hasAny: hasAnyPermission,
    hasAll: hasAllPermissions,
  }), [user, hasPermission, hasAnyPermission, hasAllPermissions]);

  return permissions;
}
